import {
  apiUrl,
  getList,
  getSingleRecord,
  saveRecord,
  deleteRecord,
  getAll,
  exportData,
  removeBlankProperties,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { KeyUploaderListItem } from '../types/api/keyUploaders';

const baseUrl = apiUrl + '/keyUploaders/';

export function getUploaders(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<KeyUploaderListItem>> {
  return getList<KeyUploaderListItem>(`${baseUrl}search`, params);
}

export function getUploaderById(id: string): Promise<KeyUploaderListItem> {
  return getSingleRecord<KeyUploaderListItem>(baseUrl, id);
}

export function saveUploader(uploader: Record<string, unknown>): Promise<KeyUploaderListItem> {
  removeBlankProperties(uploader);
  return saveRecord(baseUrl, uploader);
}

export function deleteUploader(id: string): Promise<{ id: string }> {
  return deleteRecord(baseUrl, id);
}

export function getUploadersForKeyProvider(
  keyProviderId: string
): Promise<KeyUploaderListItem[]> {
  return getAll(`${baseUrl}keyProvider/${keyProviderId}`);
}

export function getUploadersForKeyWorkflow(
  keyWorkflowId: string
): Promise<KeyUploaderListItem[]> {
  return getAll(`${baseUrl}keyWorkflow/${keyWorkflowId}`);
}

export function getUploadersForPlatform(
  platformId: string
): Promise<KeyUploaderListItem[]> {
  return getAll(`${baseUrl}platform/${platformId}`);
}

export function exportUploadersData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/keyUploaders/search`, 'name', params);
}
